import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AppService } from '../../../shared/services/app.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  payrollUrl: string;
  benefitsUrl: string;
  hubUrl: string;
  timeoffUrl: string;
  loadApps: boolean;
  loadedApps: string[];
  apps: any;
  currentApp: string;

  constructor(
    private appService: AppService,
    private titleService: Title
  ) {

  }

  ngOnInit() {
    let token = localStorage.token;
    let email = localStorage.userEmail;
    let currentUser = localStorage['lscache-currentUser'] || '{}';
    this.payrollUrl = environment.payrollUrl;
    this.benefitsUrl = `${environment.benefitsUrl}/#/welcome/getsavedstate`;
    this.hubUrl = `${environment.hubUrl}?token=${token}&email=${email}&currentUser=${currentUser}`;
    this.timeoffUrl = `${environment.timeoffUrl}?token=${token}&email=${email}&currentUser=${currentUser}`;
    this.apps = {
      'benefits': {
        name: 'Benefits',
        icon: 'fa-smile-o',
        url: this.benefitsUrl
      },
      'payroll': {
        name: 'Payroll',
        icon: 'fa-money',
        url: this.payrollUrl
      },
      'hub': {
        name: 'Hub',
        icon: 'fa-home',
        url: this.hubUrl
      },
      'timeoff': {
        name: 'Time Off',
        icon: 'fa-rocket',
        url: this.timeoffUrl
      },
    }
    this.titleService.setTitle('Welcome');

  }

  runApp(appName: string) {
    this.loadApps = true;
    this.appService.loadApp(appName);
    this.currentApp = appName;
    this.loadedApps = this.appService.getLoadedApps();
  }

  closeApp() {
    this.appService.closeApp(this.currentApp);
    this.loadedApps = this.appService.getLoadedApps();
    if (this.loadedApps.length == 0) {
      this.loadApps = false;
    }
    else {
      this.currentApp = this.loadedApps[0];
    }
  }

  closeMenuApp(appName: string) {
    this.appService.closeApp(appName);
    this.loadedApps = this.appService.getLoadedApps();
    if (this.loadedApps.length == 0) {
      this.loadApps = false;
    }
    else {
      this.currentApp = this.loadedApps[0];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/home-page/home-page.component.ts